import { useMutation } from '@tanstack/react-query';

import { START_LOGIN_KEY, startLogin as startLoginApi } from '../../utils/api';
import type { IOAuth2Config } from '../../utils/types';
import { useMessage } from '../../../hooks/useMessage';

interface IUseStartLoginProps {
  config: IOAuth2Config;
  onError?: (error: unknown) => void;
}

const useStartLogin = ({ config, onError }: IUseStartLoginProps) => {
  const message = useMessage();

  const mutation = useMutation({
    mutationKey: [START_LOGIN_KEY],
    mutationFn: () => startLoginApi(config),
    onError: (error: unknown) => {
      if (onError) {
        onError(error);
      } else {
        message.error('Error starting login process');
        console.error('Login error:', error);
      }
    },
    retry: false,
  });

  return {
    startLogin: mutation.mutate,
    startLoginAsync: mutation.mutateAsync,
    isStartingLogin: mutation.isPending,
    startLoginError: mutation.error,
    status: mutation.status,
  };
};

export default useStartLogin;
